// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "中国近现代史纲要",
      "tec": "果金凤",
      "week": "1,4-14周",
      "add": "教学楼A座325电力"
    },
    [
      {
        "sub": "概率论与数理统计",
        "tec": "石立琼",
        "week": "1,4-18单周",
        "add": "教学楼A座126信息"
      },
      {
        "sub": "数据结构与算法",
        "tec": "张聿博",
        "week": "4-18双周",
        "add": "教学楼C座403管理"
      }
    ],
    {
      "sub": "电路II",
      "tec": "李艳",
      "week": "1,4-10周",
      "add": "教学楼A座123信息"
    },
    {
      "sub": "科技文献检索",
      "tec": "勇世英",
      "week": "1,4-5,7周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "就业创业指导",
      "tec": "张融雪",
      "week": "4-8周",
      "add": "实训楼F座301信息"
    }
  ],
  "2": [
    {
      "sub": "电路II",
      "tec": "李艳",
      "week": "1,4-10周",
      "add": "教学楼A座122信息"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "25计理1-1",
        "tec": "文菲",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25计理2-1",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "教学楼A座125信息"
      },
      {
        "sub": "25计理1-2",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      }
    ],
    {
      "sub": "大学物理（下)",
      "tec": "任婕",
      "week": "1,4-16周",
      "add": "实训楼F座302信息"
    },
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "电子技术基础",
        "tec": "秦宏",
        "week": "1,4-12,15-18周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "科技应用文写作与沟通艺术",
        "tec": "商晶",
        "week": "1,4-18周",
        "add": "教学楼A座321电力"
      }
    ],
    {
      "sub": "中国近现代史纲要",
      "tec": "果金凤",
      "week": "1,4-14周",
      "add": "实训楼F座301信息"
    },
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "10-13周",
      "add": "教学楼C座213教务"
    }
  ],
  "4": [
    {
      "sub": "大学物理（下)",
      "tec": "任婕",
      "week": "1,4-16周",
      "add": "教学楼A座127信息"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "石立琼",
      "week": "1,4-18周",
      "add": "教学楼A座126信息"
    },
    0,
    [
      {
        "sub": "体育（三）",
        "tec": "李莉",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "女羽",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "足球",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "女乒",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "搏击",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男篮",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男篮",
        "tec": "郝策",
        "week": "1-12,14-18周",
        "add": "男篮"
      },
      {
        "sub": "男网",
        "tec": "李灏",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男乒",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "健美操",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "男篮"
      }
    ],
    0
  ],
  "5": [
    {
      "sub": "电路II",
      "tec": "李艳",
      "week": "1,4-10周",
      "add": "教学楼A座119信息"
    },
    {
      "sub": "数据结构与算法",
      "tec": "张聿博",
      "week": "1,4-18周",
      "add": "教学楼C座404管理"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "25计理1-2",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25计理1-3",
        "tec": "文菲",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      },
      {
        "sub": "25计理2-1",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "教学楼A座119信息"
      }
    ],
    {
      "sub": "电子技术基础",
      "tec": "秦宏",
      "week": "1,4-12,15-18单周",
      "add": "实训楼F座203自控"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
